import { useIntl } from 'react-intl'

import { Scrollable } from '@tribeplatform/react-ui-kit/Scrollable'

import { ResultsView } from '../../SmartSearch.types.js'
import { SectionTitle } from '../SmartSearchResults/SectionTitle.js'
import { useRecentSearch } from './hooks/index.js'
import { RecentSearchItem } from './RecentSearchItem.js'

type Props = {
  onItemClick: (searchTerm: string) => void
  view: ResultsView
}

export const RecentSearches = ({ onItemClick, view }: Props) => {
  const { list } = useRecentSearch()
  const { $t } = useIntl()

  if (!list.length) {
    return null
  }

  return (
    <div className="flex flex-col pb-3">
      <SectionTitle
        title={$t({
          id: 'SmartSearch.RecentSearches',
          defaultMessage: 'Recent searches',
        })}
        view={view}
        className="static"
      />
      <div className="px-4">
        <Scrollable gradientFrom="from-surface" gradientVia="via-surface">
          <div className="flex gap-2 p-1">
            {list.map(item => (
              <RecentSearchItem
                key={item}
                searchTerm={item}
                onClick={onItemClick}
              />
            ))}
          </div>
        </Scrollable>
      </div>
    </div>
  )
}
